const hideCommentBox = () => {
  let commentBox = document.querySelector('#commentBoxContainer #commentBox');

  if (commentBox) {
    commentBox.style.transform = `translate(-9999px, -9999px)`;
  }
};

export default hideCommentBox;
